/**
 * SocialVideo Component
 *
 * Video player for the PhoneCarousel with play/pause controls.
 */

import React from "react";
import ReactPlayer from "react-player";
import VisuallyHidden from "../VisuallyHidden";
import Icon from "../Icon";
import { useActiveSlide } from "../../context/active-slide-context";
import * as styles from "./SocialVideo.module.scss";

const SocialVideoWrapper = ({ children }) => {
  return <div className={styles.videoWrapper}>{children}</div>;
};

const SocialVideo = ({ index, url }) => {
  const { activeIndex } = useActiveSlide();
  const [isPlaying, setIsPlaying] = React.useState(false);
  const isActive = index === activeIndex;

  // Auto-play when slide becomes active, stop when inactive
  React.useEffect(() => {
    if (isActive) {
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  }, [isActive]);

  return (
    <div className={styles.wrapper}>
      <ReactPlayer
        url={url}
        playsinline
        wrapper={SocialVideoWrapper}
        playing={isPlaying}
        muted
        loop
        width="100%"
        height="100%"
      />
      <div className={styles.buttonsWrapper}>
        <button
          className={`${styles.controlButton} ${styles.playButton}`}
          onClick={() => setIsPlaying(prevIsPlaying => !prevIsPlaying)}
          data-playing={isPlaying}
        >
          {isPlaying ? <Icon name="pause" /> : <Icon name="play" />}
          <VisuallyHidden>{isPlaying ? "Pause" : "Play"} video</VisuallyHidden>
        </button>
      </div>
    </div>
  );
};

export default SocialVideo;
